export default __webpack_public_path__ + "static/media/slide99.87561e4a.jpg";